import { Datagrid, ListProps, TextField, TopToolbar } from 'react-admin';
import { CustomList, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function MessageSubjectsList(props: ListProps) {
  return (
    <CustomList {...props} sort={{ field: 'name', order: 'ASC' }}>
      <Datagrid rowClick="edit">
        <TextField label="Nome" source="name" sortable={false} />
        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
